import React from "react";

const ModuleBreak: React.FC = () => {
   return (<div className="management-module-break"></div>)
}

export default ModuleBreak